import React from 'react';
import styled from 'styled-components';
import {riskFactorShape} from '../../shapes';
import {labels} from '../../../../../util/utils';

function RiskFactorsSummaryListItem({riskFactor, isThisNotaROMM}) {
	return (
		<>
			<StyledRiskFactorsSummaryListItem className="StyledRiskFactorsListItem">
				<span className="risk-name-summary">{labels.riskFactorLabel}</span>
				<span className="not-a-romm-riskfactor-name">{riskFactor?.riskFactorName}</span>
				{isThisNotaROMM && <span className="risk-name-summary">{labels.description}</span>}
				{riskFactor?.customDescription?.length > 0 && (
					<span className={isThisNotaROMM ? 'riskfactor-description' : 'not-a-romm-riskfactor-description'}>
						{!isThisNotaROMM && (
							<section className={'associate-risk-summary-description-label'}>{labels.description}</section>
						)}
						<section className="associate-risk-summary-description-text">{riskFactor.customDescription}</section>
					</span>
				)}
				{riskFactor?.rationale?.length > 0 && (
					<>
						<span className="risk-rationale-label">{labels.rationaleLabel}</span>
						<span className="riskfactor-rationale">{riskFactor.rationale}</span>
					</>
				)}
			</StyledRiskFactorsSummaryListItem>
		</>
	);
}

RiskFactorsSummaryListItem.propTypes = {
	riskFactor: riskFactorShape.isRequired
};

export default RiskFactorsSummaryListItem;

const StyledRiskFactorsSummaryListItem = styled.li`
	padding: 0;
	border: none;
	.riskfactor-name {
		display: block;
		width: 100%;
		font-size: var(--px-16);
		padding-right: var(--px-40);
		padding-bottom: var(--px-10);
		.riskfactor-link {
			display: block;
			width: 100%;
			font-size: var(--px-14);
			box-shadow: none;
			border: none;
			&:hover {
				color: var(--blue-600);
			}
		}
	}
	.riskfactor-description {
		display: block;
		width: 100%;
		padding-bottom: var(--px-5);
		font-size: var(--px-16);
	}
`;
